import { Candidate } from '../../../models/candidate';
import { CandidatesQueryFilter } from '../../../models/candidatesQueryFilter';
import { CandidateDisplayQueryFilter } from '../../../models/candidateDisplayQueryFilter';
export class CandidatesPageController {
    /*@ngInject*/
    constructor($scope, $rootScope, $timeout, $filter, StorageService, genericService, jobService, candidateService, jobMatchService, companyService, userRoleService, stateManagementStorageService, alertsAndNotificationsService, MESSAGECONSTANTS, sharedAjsService) {
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.StorageService = StorageService;
        this.genericService = genericService;
        this.jobService = jobService;
        this.candidateService = candidateService;
        this.jobMatchService = jobMatchService;
        this.companyService = companyService;
        this.userRoleService = userRoleService;
        this.stateManagementStorageService = stateManagementStorageService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
        this.sharedAjsService = sharedAjsService;
    }
    $onInit() {
        //variables
        this.$stateParams = this.$transition$.params();
        this.candidates = [];
        this.salaryDurationOptions = [];
        this.filterSalaryDurationOptions = [];
        this.filterRateDurationOptions = [];
        this.selectedJobMatchStates = [];
        this.jobMatchStates = [];
        this.candidatesCount = 0;
        this.candidatesContainer = null;
        this.userId = null;
        this.infoOfCandidateInContext = null;
        this.companyType = null;
        this.clientOrBuList = null;
        this.candidateStatusList = null;
        this.requisitionStatusList = null;
        this.recruitersList = [];
        this.vendors = [];
        this.requisitionNumbersList = null;
        this.candidateInfoTemplate = '';
        this.candidateInfoContainerId = null;
        this.selectedDateRange = '';
        this.activityMap = [];
        this.divident = 4;
        this.activeTabIndex = 1;
        this.showFiltersPanel = false;
        this.isFiltersChanged = false;
        this.savedFilters = null;
        this.visibilityFilters = {
            unassigned: '',
            assignedToMe: '',
            assignedToOthers: ''
        };
        this.sortByFilters = [
            {
                "column": "status",
                "columnDisplayName": "Candidate Status"
            },
            {
                "column": "createdDate",
                "columnDisplayName": "Creation Date"
            },
            {
                "column": "email",
                "columnDisplayName": "Email"
            },
            {
                "column": "firstName",
                "columnDisplayName": "First Name"
            },
            {
                "column": "lastName",
                "columnDisplayName": "Last Name"
            },
            {
                "column": "updatedDate",
                "columnDisplayName": "Most Recently Updated"
            },
            {
                "column": "phone",
                "columnDisplayName": "Phone"
            },
            {
                "column": "recruiterList",
                "columnDisplayName": "Recruiters"
            },
            {
                "column": "requisitionNumbers",
                "columnDisplayName": "Requisition Number"
            },
            {
                "column": "requisitionStatus",
                "columnDisplayName": "Requisition Status"
            }
        ];
        this.selectedSort = 'Please Select';
        this.selectedSortDirection = '';
        // selected lists
        this.selectedClientOrBuList = [];
        this.selectedRequisitionStatusList = [];
        this.selectedRecruitersList = [];
        this.selectedVendors = [];
        this.selectedRequisitionNumbersList = [];
        this.candidateFilterItemsSelected = [];
        this.selectedPreferredJobTypeAdditionalList = [];
        this.candidateJobMatchActiveTab = {};
        // this.selectedCandidateStatusList = ["Active","Passive","Inert"];
        //flags
        this.isVendorCompany = false;
        this.hideSearchStringFlag = false;
        this.candidatesExistFlag = true;
        this.showCandidateInfo = false;
        this.loadingClientsOrBusFilter = true;
        this.loadingCandidateStatusesFilter = true;
        this.loadingRequisitionStatusesFilter = true;
        this.loadingRequisitionNumbersFilter = true;
        this.loadingJobMatchStatesFilter = true;
        this.loadingVendorsFilter = true;
        this.loadingRecruitersFilter = true;
        this.loadingWorkLocationsFilter = true;
        this.emptyCandidateSelectedFilter = false;
        this.loadingPreferredJobTypeFilter = true;
        this.loadingWorkAuthorizationFilter = true;
        this.loadingAdditionalPreferredJobTypeFilter = true;
        this.isDisplayRateFilterActive = false;
        this.queryCandidates = _.debounce(this.queryCandidates, 900);
        this.init();
        this._handleFilterDisplay();
    }
    init() {
        if (window.innerWidth < 1400) {
            this.divident = 3;
        }
        this.isVendorCompany = this.companyService.isCompanyVendor();
        this.candidates = [];
        this.candidatesContainer = new CandidatesContainer(this.$rootScope, this.divident, this.candidateService, this.alertsAndNotificationsService);
        this.userId = this.$rootScope.userDetails.id;
        this.userName = this.$rootScope.userDetails.firstname + ' ' + this.$rootScope.userDetails.lastname;
        this.companyType = this.$rootScope.userDetails.company.companyType;
        if (this.companyType == "StaffingCompany") {
            let clientOrBu = {
                "column": "clientOrBuList",
                "columnDisplayName": "Client"
            };
            this.sortByFilters.splice(1, 0, clientOrBu);
        }
        else {
            let clientOrBu = {
                "column": "clientOrBuList",
                "columnDisplayName": "BU"
            };
            this.sortByFilters.splice(0, 0, clientOrBu);
        }
        // Remove candidate screen on company switch (in super user)
        this._checkAndRemoveIfFilterExistsWithCompanyId();
        let savedFilters = this.stateManagementStorageService.getScreenState(`candidatesScreen-${this.userId}`);
        this.defaultFilters = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        if (savedFilters && this.$stateParams.searchString == null
            && this.$stateParams.candidateStatuses == null
            && this.$stateParams.recruiters == null
            && this.$stateParams.visibilityFilters == null
            && this.$stateParams.searchString == null
            && this.$stateParams.candidateType == null
            && this._checkIfNewFiltersAdded(this.defaultFilters, savedFilters)) {
            this.candidatesContainer.candidatesQueryFilter = angular.copy(savedFilters);
            this.savedFilters = angular.copy(savedFilters);
        }
        else {
            this._setSalaryAndRate();
            this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.defaultFilters);
        }
        // Display Selected Filters
        this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
        let savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState(`candidatesScreen-displayFilter-${this.userId}`);
        if (savedDisplayedCandidateSelectedFilter && this._checkIfNewFiltersAdded(this.displayCandidateSelectedFilter, savedDisplayedCandidateSelectedFilter)) {
            if (this.$stateParams.candidateStatuses) {
                savedDisplayedCandidateSelectedFilter.searchString = "";
                this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, savedDisplayedCandidateSelectedFilter);
            }
            this.displayCandidateSelectedFilter = angular.copy(savedDisplayedCandidateSelectedFilter);
            // Set Sort By Filter to Null
            // this.displayCandidateSelectedFilter.selectedFilterSort = "";
            this.savedDisplayedCandidateSelectedFilter = angular.copy(savedDisplayedCandidateSelectedFilter);
            if (_.isUndefined(this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon)) {
                this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
            }
        }
        else {
            this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
            this.savedDisplayedCandidateSelectedFilter = angular.copy(this.displayCandidateSelectedFilter);
        }
        this.showCandidateDisplaySelectedFilterPanel = this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        this._setStateParamsFilter();
        // this._setCandidatesTypeFilter();
        this._setCandidatesSortFilter();
        // get all the filter data
        this.getAllClientsOrBu(() => {
            this.getAllRequisitionNumbers(() => {
                this.getAllRecruiters(() => {
                    // check if any state params are present and add them onto the filters
                    if (!_.isNull(this.$stateParams.recruiters) && _.isArray(this.$stateParams.recruiters)) {
                        this.candidatesContainer.candidatesQueryFilter.recruiterList = this.$stateParams.recruiters;
                        this._setFilterValues('Recruiters', this.$stateParams.recruiters);
                    }
                    this.getAllRequisitionStatuses(() => {
                        this.getAllWorkLocations(() => {
                            this.getAllJobMatchStates(() => {
                                if (this.companyType == 'Corporation') {
                                    this.getAllVendors(() => {
                                        this.savedFilters = null;
                                    });
                                }
                                else {
                                    this.loadingVendorsFilter = false;
                                    this.savedFilters = null;
                                }
                            });
                        });
                    });
                });
            });
        });
        this.getAllCandidateStatuses(() => {
            // check if any state params are present and add them onto the filters
            if (!_.isNull(this.$stateParams.candidateStatuses) && _.isArray(this.$stateParams.candidateStatuses)) {
                this.candidatesContainer.candidatesQueryFilter.status = this.$stateParams.candidateStatuses;
                this._setFilterValues('CandidateStatus', this.$stateParams.candidateStatuses);
            }
        });
        this.getAllActivityTypes();
        this.getSalaryDurationOptions();
        this.getAllPreferredJobTypes();
        this.getAllAdditionalPreferredJobTypes();
        this.getAllWorkAuthorizations();
        this.getCurrencyCodes();
        this._setDisplaySalaryAndRateFilter();
        this.isRowViewActive = false;
        this.currentCandidatePage = 1;
        this._setCandidateRowViewStatus();
    }
    _setCandidateRowViewStatus() {
        let checkIfRowViewActive = this.stateManagementStorageService.getScreenState(`candidatesScreen-rowView-${this.userId}`);
        if (checkIfRowViewActive) {
            this.isRowViewActive = checkIfRowViewActive.isRowViewActive;
            if (this.isRowViewActive) {
                this.candidatesContainer.getNextPage(this.currentCandidatePage);
            }
        }
    }
    toggleCandidateRowView() {
        this.isRowViewActive = !this.isRowViewActive;
        this.stateManagementStorageService.setScreenState(`candidatesScreen-rowView-${this.userId}`, { isRowViewActive: this.isRowViewActive });
        if (this.isRowViewActive) {
            this.closeCandidateInfoRow();
            this.candidatesContainer.getNextPage(this.currentCandidatePage);
        }
        else {
            // Reset Candidate card view
            this.candidatesContainer.candidatesExistFlag = true;
            this.candidatesContainer.candidatesQueryFilter.pageNum = 1;
            this.candidatesContainer.candidates = [];
            this.candidatesContainer.disableInfiniteScroll = false;
        }
    }
    _checkIfNewFiltersAdded(defaultFilters, savedFilters) {
        let checkIfFilterIsOld = Object.keys(defaultFilters).every(filter => {
            return Object.keys(savedFilters).includes(filter);
        });
        return checkIfFilterIsOld;
    }
    _checkAndRemoveIfFilterExistsWithCompanyId() {
        let existingCandidateScreenState = this.stateManagementStorageService.getScreenState(`candidatesScreen-${this.userId}`);
        if (existingCandidateScreenState) {
            if (existingCandidateScreenState.parentCompanyId !== this.$rootScope.userDetails.company.companyId) {
                this.stateManagementStorageService.clearStateScreen(`candidatesScreen-${this.userId}`);
                this.stateManagementStorageService.clearStateScreen(`candidatesScreen-displayFilter-${this.userId}`);
            }
        }
    }
    _setStateParamsFilter() {
        if (this.$stateParams.searchString && this.$stateParams.searchString != '') {
            // Reset Filters
            this.defaultFilters = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
            this.candidatesContainer.candidatesQueryFilter = angular.copy(this.defaultFilters);
            this.candidatesContainer.candidatesQueryFilter.searchString = this.$stateParams.searchString;
            this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.candidatesContainer.candidatesQueryFilter);
            this.savedFilters = angular.copy(this.candidatesContainer.candidatesQueryFilter);
            // Reset Display Filters
            this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
            this.displayCandidateSelectedFilter.searchString = this.candidatesContainer.candidatesQueryFilter.searchString;
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
            this.savedDisplayedCandidateSelectedFilter = angular.copy(this.displayCandidateSelectedFilter);
        }
        if (!_.isNull(this.$stateParams.visibilityFilters)) {
            this.visibilityFilters = this.$stateParams.visibilityFilters;
            if (this.visibilityFilters.unassigned != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
            }
            if (this.visibilityFilters.assignedToMe != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
            }
            if (this.visibilityFilters.assignedToOthers != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
            }
        }
        else {
            this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
            this.visibilityFilters.unassigned = 'unassigned';
            this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
            this.visibilityFilters.assignedToOthers = 'assignedToOthers';
            this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
            this.visibilityFilters.assignedToMe = 'assignedToMe';
        }
        if (!_.isNull(this.$stateParams.candidateType)) {
            this.candidatesContainer.candidatesQueryFilter.candidateType = this.$stateParams.candidateType;
        }
        this.StorageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType);
    }
    // _setCandidatesTypeFilter() {
    //     let previouslySelectedCandidatesType = this.StorageService.get('candidatesType');
    //     if(!_.isNull(this.$stateParams.candidateType)) {
    //         this.candidatesContainer.candidatesQueryFilter.candidateType = this.$stateParams.candidateType;
    //     } else if(!_.isNull(previouslySelectedCandidatesType) && previouslySelectedCandidatesType !== undefined && this.companyType == 'Corporation') {
    //         this.candidatesContainer.candidatesQueryFilter.candidateType = previouslySelectedCandidatesType;
    //     } else {
    //         this.candidatesContainer.candidatesQueryFilter.candidateType = "OWN_CANDIDATES";
    //     }
    //     this.StorageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType);
    // }
    _setCandidatesSortFilter() {
        if (!_.isNull(this.savedFilters) && !_.isUndefined(this.savedFilters.sortDirection) && !_.isUndefined(this.savedFilters.column)) {
            // let sortByFilter = this.StorageService.get(`candidatesSortFilter-${this.userId}`);
            // if(!_.isNull(sortByFilter) && !_.isUndefined(sortByFilter)){
            //     this.selectedSort = sortByFilter.sortBy.columnDisplayName;
            //     this.candidatesContainer.candidatesQueryFilter.column = sortByFilter.sortBy.column;
            //     this.selectedSortDirection = 'Asc';
            //     this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
            //     if(sortByFilter.direction == 'Desc') {
            //         this.selectedSortDirection = 'Desc';
            //         this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
            //     }
            // }
            this.sortByFilters.forEach(filter => {
                if (filter.column == this.savedFilters.column) {
                    this.selectedSort = filter.columnDisplayName;
                }
            });
            this.candidatesContainer.candidatesQueryFilter.column = this.savedFilters.column;
            if (this.savedFilters.sortDirection == 'DESC') {
                this.selectedSortDirection = 'Desc';
                this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
            }
            else {
                this.selectedSortDirection = 'Asc';
                this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
            }
        }
        if (this.savedDisplayedCandidateSelectedFilter.selectedFilterSort.length > 0 || this.savedDisplayedCandidateSelectedFilter.searchString.length > 0) {
            this.setCandidateDisplayedFilterItemSelected(this.savedDisplayedCandidateSelectedFilter);
        }
    }
    onCandidatesTypeChanged() {
        this.candidateInfoContainerId = null;
        this.candidateJobMatchesTabChanged('jobMatches');
        this.StorageService.set('candidatesType', this.candidatesContainer.candidatesQueryFilter.candidateType);
        this.queryCandidates();
        if (this.candidatesContainer.candidatesQueryFilter.candidateType === 'OWN_CANDIDATES') {
            this.displayCandidateSelectedFilter.vendors = [];
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        }
        else {
            this.onVendorClick();
            this._setSalaryAndRateDefaultValues('salary');
            this._setSalaryAndRateDefaultValues('rate');
            this.displayCandidateSelectedFilter.salary = "";
            this.displayCandidateSelectedFilter.rate = "";
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        }
    }
    getAllVendors(successCallback) {
        this.loadingVendorsFilter = true;
        this.companyService.getVendorsByUserScope(this.$rootScope.userDetails.company.companyId, (data) => {
            this.vendors = data;
            this.loadingVendorsFilter = false;
            if (this.savedFilters !== null) {
                this.selectedVendors = this.vendors.filter(vendor => this.savedFilters.vendors.some(vendorId => vendorId == vendor.id));
                this.selectedVendors.forEach(vendor => vendor.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.vendors.length !== 0 || this.candidatesContainer.candidatesQueryFilter.vendors.length !== 0) {
                this.displayCandidateSelectedFilter.vendors = this.selectedVendors.map((val, index) => {
                    return val.name;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingVendorsFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    resetCandidateQueryFilters() {
        this.isFiltersChanged = true;
        this.selectedDateRange = '';
        angular.forEach(this.candidateStatusList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.recruitersList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.vendors, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.requisitionNumbersList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.requisitionStatusList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.clientOrBuList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.jobMatchStates, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.workLocationList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.preferredJobTypeList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.preferredJobTypeAdditionalList, (val, key) => {
            val.ticked = false;
        });
        angular.forEach(this.workAuthorizationList, (val, key) => {
            val.ticked = false;
        });
        if (this.selectedSort != "Please Select") {
            this.selectedSort = "Please Select";
            this.selectedSortDirection = "";
            delete (this.candidatesContainer.candidatesQueryFilter.column);
            delete (this.candidatesContainer.candidatesQueryFilter.sortDirection);
        }
        this.candidatesContainer.candidatesQueryFilter = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        // Reset Salary and Rate
        this._setSalaryAndRate();
        //to set existing visibility filters
        this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
        this.visibilityFilters.unassigned = 'unassigned';
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
        this.visibilityFilters.assignedToOthers = 'assignedToOthers';
        this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
        this.visibilityFilters.assignedToMe = 'assignedToMe';
        // this.visibilityFilterChanged();
        // Reset Displayed Selected Filters
        this.displayCandidateSelectedFilter = new CandidateDisplayQueryFilter();
        let savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState(`candidatesScreen-displayFilter-${this.userId}`);
        this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = savedDisplayedCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    _setFilterValues(label, arrayOfFilterValues) {
        switch (label) {
            case 'CandidateStatus':
                angular.forEach(this.candidateStatusList, (candidateStatus, key) => {
                    if (arrayOfFilterValues.indexOf(candidateStatus.value) != -1) {
                        candidateStatus.ticked = true;
                    }
                });
                break;
            case 'Recruiters':
                angular.forEach(this.recruitersList, (recruiter, key) => {
                    if (arrayOfFilterValues.indexOf(recruiter.userId) != -1) {
                        recruiter.ticked = true;
                    }
                });
                break;
            default:
                break;
        }
    }
    selectRemoveAll(label, type, doQueryFlag) {
        if (type == 'selectAll') {
            switch (label) {
                case 'Clients':
                    this.selectedClientOrBuList = [...this.clientOrBuList];
                    this.onClientClick();
                    break;
                case 'CandidateStatus':
                    this.selectedCandidateStatusList = [...this.candidateStatusList];
                    this.onCandidateStatusClick();
                    break;
                case 'RequisitionStatus':
                    this.selectedRequisitionStatusList = [...this.requisitionStatusList];
                    this.onRequisitionStatusClick();
                    break;
                case 'Recruiters':
                    this.selectedRecruitersList = [...this.recruitersList];
                    this.onRecruiterClick();
                    break;
                case 'Vendors':
                    this.selectedVendors = [...this.vendors];
                    this.onVendorClick();
                    break;
                case 'RequisitionNumbers':
                    this.selectedRequisitionNumbersList = [...this.requisitionNumbersList];
                    this.onRequisitionNumbersClick();
                    break;
                case 'JobMatchStates':
                    this.selectedJobMatchStates = [...this.jobMatchStates];
                    this.onJobMatchStateClick();
                    break;
                case 'WorkLocations':
                    this.selectedWorkLocationList = [...this.workLocationList];
                    this.onWorkLocationClick();
                    break;
                case 'PreferredJobType':
                    this.selectedPreferredJobTypeList = [...this.preferredJobTypeList];
                    this.onPreferredJobTypeClick();
                    break;
                case 'jobSubTypes':
                    this.selectedPreferredJobTypeAdditionalList = [...this.preferredJobTypeAdditionalList];
                    this.onAdditionalPreferredJobTypeClick();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = [...this.workAuthorizationList];
                    this.onWorkAuthorizationClick();
                    break;
                default:
                //do nothing;
            }
        }
        else {
            switch (label) {
                case 'Clients':
                    this.selectedClientOrBuList = [];
                    this.onClientClick();
                    break;
                case 'CandidateStatus':
                    this.selectedCandidateStatusList = [];
                    this.onCandidateStatusClick();
                    break;
                case 'RequisitionStatus':
                    this.selectedRequisitionStatusList = [];
                    this.onRequisitionStatusClick();
                    break;
                case 'Recruiters':
                    this.selectedRecruitersList = [];
                    this.onRecruiterClick();
                    break;
                case 'Vendors':
                    this.selectedVendors = [];
                    this.onVendorClick();
                    break;
                case 'RequisitionNumbers':
                    this.selectedRequisitionNumbers = [];
                    this.onRequisitionNumbersClick();
                    break;
                case 'JobMatchStates':
                    this.selectedJobMatchStates = [];
                    this.onJobMatchStateClick();
                    break;
                case 'WorkLocations':
                    this.selectedWorkLocationList = [];
                    this.onWorkLocationClick();
                    break;
                case 'PreferredJobType':
                    this.selectedPreferredJobTypeList = [];
                    this.onPreferredJobTypeClick();
                    break;
                case 'jobSubTypes':
                    this.selectedPreferredJobTypeAdditionalList = [];
                    this.onAdditionalPreferredJobTypeClick();
                    break;
                case 'sponsorships':
                    this.selectedWorkAuthorizationList = [];
                    this.onWorkAuthorizationClick();
                    break;
                default:
                //do nothing
            }
        }
    }
    visibilityFilterChanged() {
        this.onGlobalFilterChange();
        this.getAllRecruiters(() => {
            this.candidatesContainer.candidatesQueryFilter.visibility = [];
            if (this.visibilityFilters.assignedToMe != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToMe');
                if (this._currentUserExistsInAssignedRecruitersList()) {
                    angular.forEach(this.recruitersList, (val, key) => {
                        if (val.userId == this.userId) {
                            val.ticked = true;
                        }
                    });
                }
                else if (!this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
                    this.recruitersList.unshift({ name: this.userName, selectedDisplayName: this.$filter('displayOnMultiSelectFilter')(this.userName), userId: this.userId, ticked: true });
                }
            }
            else {
                this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId !== this.userId);
            }
            this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId !== 'UNASSIGNED');
            if (this.visibilityFilters.unassigned != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('unassigned');
                let unAssignedRecruiter = { name: 'Unassigned', selectedDisplayName: 'Unassigned', userId: 'UNASSIGNED', ticked: true };
                this.recruitersList.unshift(unAssignedRecruiter);
            }
            this.selectedRecruitersList = [];
            angular.forEach(this.recruitersList, (val, key) => {
                if (val.userId !== this.userId && val.userId !== 'UNASSIGNED') {
                    val.ticked = true;
                }
                if (val.ticked) {
                    this.selectedRecruitersList.push(val);
                }
            });
            if (this.visibilityFilters.assignedToOthers != '') {
                this.candidatesContainer.candidatesQueryFilter.visibility.push('assignedToOthers');
            }
            else {
                this._removeOtherRecruiters();
            }
            if (this.candidatesContainer.candidatesQueryFilter.visibility.length == 3) {
                this.candidatesContainer.allAssignedRecruitersCount = this.recruitersList.length;
            }
            this.onRecruiterClick();
        });
    }
    candidateCompensationChanged() {
        this.onGlobalFilterChange();
    }
    onClientClick(selectedClients) {
        this.isFiltersChanged = true;
        this.getAllRequisitionNumbers(() => {
            this.getAllRecruiters(() => {
                this.candidatesContainer.candidatesQueryFilter.clientOrBuList = this.selectedClientOrBuList.map((val, index) => {
                    return val.id;
                });
                this.candidatesContainer.candidatesQueryFilter.requisitionNumbers = this.selectedRequisitionNumbersList.map((val, index) => {
                    return val.value;
                });
                this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
                    return val.userId;
                });
                this.displayCandidateSelectedFilter.clientOrBuList = this.selectedClientOrBuList.map((val, index) => {
                    if (val.companyType === 'Corporation') {
                        return val.shortName;
                    }
                    else {
                        return val.name;
                    }
                });
                this.displayCandidateSelectedFilter.requisitionNumbers = this.candidatesContainer.candidatesQueryFilter.requisitionNumbers;
                this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
                    if (val.firstName === null || val.firstName === undefined) {
                        return val.name;
                    }
                    else {
                        return val.firstName;
                    }
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            });
        });
    }
    onJobMatchStateClick(selectedJobMatches) {
        this.isFiltersChanged = true;
        // set the selected clients on the query filter
        this.candidatesContainer.candidatesQueryFilter.workflowStates = this.selectedJobMatchStates.map((val, index) => {
            return val.value;
        });
        this.displayCandidateSelectedFilter.workflowStates = this.candidatesContainer.candidatesQueryFilter.workflowStates;
        this.displayCandidateSelectedFilter.workflowStates = this.displayCandidateSelectedFilter.workflowStates.filter(val => val !== undefined);
        // Filter Duplicate Values
        this.displayCandidateSelectedFilter.workflowStates = [...new Set(this.displayCandidateSelectedFilter.workflowStates)];
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onWorkLocationClick(selectedWorkLocations) {
        this.isFiltersChanged = true;
        // set the selected clients on the query filter
        this.candidatesContainer.candidatesQueryFilter.workLocationIds = this.selectedWorkLocationList.map((val, index) => {
            return val.id;
        });
        this.displayCandidateSelectedFilter.workLocationIds = this.selectedWorkLocationList.map((val, index) => {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onPreferredJobTypeClick() {
        this.isFiltersChanged = true;
        this.candidatesContainer.candidatesQueryFilter.jobTypes = this.selectedPreferredJobTypeList.map((val, index) => {
            return val.value;
        });
        this.displayCandidateSelectedFilter.jobTypes = this.selectedPreferredJobTypeList.map((val, index) => {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        this.onAdditionalPreferredJobTypeClick();
    }
    onAdditionalPreferredJobTypeClick() {
        this.isFiltersChanged = true;
        if (!this.checkPreferredJobType('CONTRACTTOHIRE') && !this.checkPreferredJobType('CONTRACTOR')) {
            this.selectedPreferredJobTypeAdditionalList = [];
        }
        this.candidatesContainer.candidatesQueryFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map((val, index) => {
            return val.value;
        });
        this.displayCandidateSelectedFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map((val, index) => {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    checkPreferredJobType(jobType) {
        let isJobTypePresent;
        if (this.selectedPreferredJobTypeList && this.selectedPreferredJobTypeList.length > 0) {
            for (let i = 0; i < this.selectedPreferredJobTypeList.length; i++) {
                if (this.selectedPreferredJobTypeList[i].value === jobType) {
                    isJobTypePresent = true;
                    break;
                }
                else {
                    isJobTypePresent = false;
                }
            }
        }
        else {
            isJobTypePresent = false;
        }
        return isJobTypePresent;
    }
    onWorkAuthorizationClick() {
        this.isFiltersChanged = true;
        this.candidatesContainer.candidatesQueryFilter.sponsorships = this.selectedWorkAuthorizationList.map((val, index) => {
            return val.value;
        });
        this.displayCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map((val, index) => {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onSalaryDurationChange() {
        if (this.candidatesContainer.candidatesQueryFilter.salaryDuration) {
            this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onRateDurationChange() {
        if (this.candidatesContainer.candidatesQueryFilter.rateDuration) {
            this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onSalaryOrRateCurrencyChange(type) {
        if (this.displayCandidateSelectedFilter.rate != "" || this.displayCandidateSelectedFilter.salary != "") {
            this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
            this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        else if (type === 'salary') {
            this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
        }
        else {
            this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onCandidateStatusClick(selectedCandidateStatus) {
        this.isFiltersChanged = true;
        // set the selected clients on the query filter
        this.candidatesContainer.candidatesQueryFilter.status = this.selectedCandidateStatusList.map((val, index) => {
            return val.value;
        });
        this.displayCandidateSelectedFilter.status = this.candidatesContainer.candidatesQueryFilter.status;
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onRequisitionStatusClick(selectedRequisitionStatus) {
        this.isFiltersChanged = true;
        // set the selected requisition statues on the query filter
        this.candidatesContainer.candidatesQueryFilter.requisitionStatus = this.selectedRequisitionStatusList.map((val, index) => {
            return val.value;
        });
        this.displayCandidateSelectedFilter.requisitionStatus = this.selectedRequisitionStatusList.map((val, index) => {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onRecruiterClick() {
        this.isFiltersChanged = true;
        // set the selected recruiters on the query filter
        this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
            return val.userId;
        });
        this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
            if (val.firstName === null || val.firstName === undefined) {
                return val.name;
            }
            else {
                return val.firstName;
            }
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onVendorClick(selectedVendor) {
        this.isFiltersChanged = true;
        // set the selected vendors on the query filter
        this.candidatesContainer.candidatesQueryFilter.vendors = this.selectedVendors.map((val, index) => {
            return val.id;
        });
        this.displayCandidateSelectedFilter.vendors = this.selectedVendors.map((val, index) => {
            return val.name;
        });
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    onRequisitionNumbersClick(selectedRequisitionNumbers) {
        this.isFiltersChanged = true;
        this.getAllRecruiters(() => {
            this.candidatesContainer.candidatesQueryFilter.clientOrBuList = this.selectedClientOrBuList.map((val, index) => {
                return val.id;
            });
            this.candidatesContainer.candidatesQueryFilter.requisitionNumbers = this.selectedRequisitionNumbersList.map((val, index) => {
                return val.value;
            });
            this.candidatesContainer.candidatesQueryFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
                return val.userId;
            });
            this.displayCandidateSelectedFilter.clientOrBuList = this.selectedClientOrBuList.map((val, index) => {
                if (val.companyType === 'Corporation') {
                    return val.shortName;
                }
                else {
                    return val.name;
                }
            });
            this.displayCandidateSelectedFilter.requisitionNumbers = this.candidatesContainer.candidatesQueryFilter.requisitionNumbers;
            this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
                if (val.firstName === null || val.firstName === undefined) {
                    return val.name;
                }
                else {
                    return val.firstName;
                }
            });
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        });
    }
    sortCandidates(sortByFilter, direction) {
        this.isFiltersChanged = true;
        if (_.isNull(sortByFilter)) {
            this.selectedSort = 'Please Select';
            this.selectedSortDirection = '';
            delete this.candidatesContainer.candidatesQueryFilter.column;
            delete this.candidatesContainer.candidatesQueryFilter.sortDirection;
        }
        else {
            this.selectedSort = sortByFilter.columnDisplayName;
            this.candidatesContainer.candidatesQueryFilter.column = sortByFilter.column;
            this.selectedSortDirection = 'Asc';
            this.candidatesContainer.candidatesQueryFilter.sortDirection = 'ASC';
            if (direction == 'Desc') {
                this.selectedSortDirection = 'Desc';
                this.candidatesContainer.candidatesQueryFilter.sortDirection = 'DESC';
            }
            // this.StorageService.set(`candidatesSortFilter-${this.userId}`, {sortBy: sortByFilter, direction: direction});
        }
        this.displayCandidateSelectedFilter.selectedFilterSort = "";
        if (sortByFilter != null) {
            this.displayCandidateSelectedFilter.selectedFilterSort = sortByFilter.columnDisplayName + " " + "(" + direction + ")";
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    queryCandidates() {
        this.candidatesContainer.loadingSearchButton = true;
        this.isFiltersChanged = false;
        this.isDisplayRateFilterActive = false;
        this.closeCandidateInfoRow();
        if (this.showFiltersPanel) {
            this._scrollDownToKeepInfiniteScrollActive();
        }
        // clear any existing query requests
        // check for an existing promise and see if it has not been fulfilled yet. If it has not been fulfilled yet, cancel the promise.
        // if(!_.isNull(this.candidatesContainer.currentPromise) && this.candidatesContainer.currentPromise.$$state.status == 0) {
        if (!_.isNull(this.candidatesContainer.currentPromise)) {
            this.genericService.cancelRequest(this.candidatesContainer.currentPromise);
        }
        // reset the initial value of candidates exist flag to true
        this.candidatesContainer.candidatesExistFlag = true;
        // reset the page number to 1 as this is a new query
        this.candidatesContainer.candidatesQueryFilter.pageNum = 1;
        this.currentRequisitionPage = 1;
        // clear the existing candidates
        this.candidatesContainer.candidates = [];
        this.candidatesContainer.disableInfiniteScroll = false;
        this.candidatesContainer.candidatesQueryFilter.workflowStates = this.candidatesContainer.candidatesQueryFilter.workflowStates.filter(state => state); //remove null and undefined values
        // Hide Display Filter
        if (this.candidateFilterItemsSelected.length === 0) {
            this.displayCandidateFilterFlag = false;
            this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = true;
        }
        // if(!_.isNull(this.candidatesContainer.currentPromise) && this.candidatesContainer.currentPromise.$$state.status == 0) {
        if (!_.isNull(this.candidatesContainer.currentPromise)) {
            // wait for the cancel promise to be fulfilled, if it was called.
            this.$timeout(() => {
                this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.candidatesContainer.candidatesQueryFilter);
                this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
                if (this.isRowViewActive) {
                    this.candidatesContainer.getNextPage(this.currentRequisitionPage);
                }
                else {
                    this.candidatesContainer.getNext();
                }
            }, 200);
        }
        else {
            this.stateManagementStorageService.setScreenState(`candidatesScreen-${this.userId}`, this.candidatesContainer.candidatesQueryFilter);
            this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, this.displayCandidateSelectedFilter);
            if (this.isRowViewActive) {
                this.candidatesContainer.getNextPage(this.currentRequisitionPage);
            }
            else {
                this.candidatesContainer.getNext();
            }
        }
    }
    _scrollDownToKeepInfiniteScrollActive() {
        if ($(window).scrollTop() < 100) {
            window.scrollTo(0, 100);
        }
    }
    _setShowCandidateDisplayFilterIcon(boolean) {
        let savedDisplayedCandidateSelectedFilter = this.stateManagementStorageService.getScreenState(`candidatesScreen-displayFilter-${this.userId}`);
        savedDisplayedCandidateSelectedFilter.showCandidateDisplayFilterIcon = boolean;
        this.stateManagementStorageService.setScreenState(`candidatesScreen-displayFilter-${this.userId}`, savedDisplayedCandidateSelectedFilter);
        if (this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon !== boolean) {
            this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = boolean;
        }
    }
    _setSalaryAndRateDisplayFilter(type) {
        let salaryOrRateFilter = "";
        if (type === 'salary') {
            salaryOrRateFilter = this.candidatesContainer.candidatesQueryFilter.salary ?
                `${this.candidatesContainer.candidatesQueryFilter.salary.toString() + " " + this.candidatesContainer.candidatesQueryFilter.currency + " " + this._setDisplayFilterSalaryOrRateDuration('salary')}` : "";
        }
        else {
            salaryOrRateFilter = this.candidatesContainer.candidatesQueryFilter.rate ?
                `${this.candidatesContainer.candidatesQueryFilter.rate.toString() + " " + this.candidatesContainer.candidatesQueryFilter.currency + " " + this._setDisplayFilterSalaryOrRateDuration('rate')}` : "";
        }
        return salaryOrRateFilter;
    }
    _setDisplayFilterSalaryOrRateDuration(type) {
        let durationOption = "";
        if (type === 'salary') {
            durationOption = this.salaryDurationOptions.filter(val => this.candidatesContainer.candidatesQueryFilter.salaryDuration === val.value)[0].name;
        }
        else {
            durationOption = this.salaryDurationOptions.filter(val => this.candidatesContainer.candidatesQueryFilter.rateDuration === val.value)[0].name;
        }
        return durationOption;
    }
    displaySelectedFilterToggle() {
        this.showCandidateDisplaySelectedFilterPanel = true;
        if (this.displayCandidateFilterFlag) {
            $("#display-candidate-selected-filter-panel").animate({
                height: 'toggle'
            });
            this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon = !this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon;
        }
        // Set Display Filter Collapse and Expand Panel
        this._setShowCandidateDisplayFilterIcon(this.displayCandidateSelectedFilter.showCandidateDisplayFilterIcon);
    }
    isFilterValueArray(value) {
        if (Array.isArray(value)) {
            return true;
        }
        else {
            return false;
        }
    }
    addToDisplayFilters(event) {
        switch (event) {
            case 'firstName':
                this.displayCandidateSelectedFilter.firstName = this.candidatesContainer.candidatesQueryFilter.firstName;
                break;
            case 'lastName':
                this.displayCandidateSelectedFilter.lastName = this.candidatesContainer.candidatesQueryFilter.lastName;
                break;
            case 'phone':
                this.displayCandidateSelectedFilter.phone = this.candidatesContainer.candidatesQueryFilter.phone;
                break;
            case 'email':
                this.displayCandidateSelectedFilter.email = this.candidatesContainer.candidatesQueryFilter.email;
                break;
            case 'search':
                this.displayCandidateSelectedFilter.searchString = this.candidatesContainer.candidatesQueryFilter.searchString;
                break;
            case 'salary':
                if (_.isUndefined(this.candidatesContainer.candidatesQueryFilter.salary) || this.candidatesContainer.candidatesQueryFilter.salary < 0) {
                    this.candidatesContainer.candidatesQueryFilter.salary = 1;
                }
                this._checkIfSalaryAndRateDurationDefault('salary');
                this.displayCandidateSelectedFilter.salary = this._setSalaryAndRateDisplayFilter('salary');
                break;
            case 'rate':
                if (_.isUndefined(this.candidatesContainer.candidatesQueryFilter.rate) || this.candidatesContainer.candidatesQueryFilter.rate < 0) {
                    this.candidatesContainer.candidatesQueryFilter.rate = 1;
                }
                this._checkIfSalaryAndRateDurationDefault('rate');
                this.displayCandidateSelectedFilter.rate = this._setSalaryAndRateDisplayFilter('rate');
                this.isDisplayRateFilterActive = true;
                break;
            default:
                break;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    _setObjectVariableName(currentObject) {
        let selectedFilterVariableNameObj = {
            requisitionStatus: "Requisition Status", requisitionNumbers: "Requisition Number",
            firstName: "First Name", lastName: "Last Name", phone: "Phone", email: "Email",
            searchString: "Search", workflowStates: "Job Match Status",
            recruiterList: "Recruiter/Hiring Manager", workLocationIds: "Work Locations",
            jobTypes: "Job Type", jobSubTypes: "Additional Contract Types", sponsorships: "Work Authorizations", salary: "Salary",
            rate: "Rate", selectedFilterSort: "Sort By"
        };
        for (var key in selectedFilterVariableNameObj) {
            if (selectedFilterVariableNameObj.hasOwnProperty(key)) {
                var obj = selectedFilterVariableNameObj[key];
                if (key == currentObject.variable) {
                    this.displaySelectedFilterObj.variable = obj;
                }
            }
        }
    }
    setCandidateDisplayedFilterItemSelected(itemsSelected) {
        this.emptyCandidateSelectedFilter = false;
        for (var key in itemsSelected) {
            if (itemsSelected.hasOwnProperty(key)) {
                var obj = itemsSelected[key];
                if (obj.length > 0) {
                    this.displayCandidateFilterFlag = true;
                    this.displaySelectedFilterObj = {};
                    if (this.candidateFilterItemsSelected.length !== 0) {
                        this.candidateFilterItemsSelected.forEach((filterItem) => {
                            if (filterItem.filter == key) {
                                if (filterItem.setSelectedFilterLimit == 5) {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                                }
                                else {
                                    this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: obj.length, expandSelectedFilter: filterItem.expandSelectedFilter };
                                }
                            }
                        });
                    }
                    if (this.candidateFilterItemsSelected.length == 0 || Object.keys(this.displaySelectedFilterObj).length == 0) {
                        this.displaySelectedFilterObj = { filter: key, variable: key, value: obj, setSelectedFilterLimit: 5, expandSelectedFilter: false };
                    }
                    this._setObjectVariableName(this.displaySelectedFilterObj);
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(item => item.variable !== this.displaySelectedFilterObj.variable);
                    }
                    this.candidateFilterItemsSelected.push(this.displaySelectedFilterObj);
                }
                else {
                    if (this.candidateFilterItemsSelected.length > 0) {
                        this.candidateFilterItemsSelected = this.candidateFilterItemsSelected.filter(item => item.filter !== key);
                    }
                }
            }
        }
        if (this.candidateFilterItemsSelected.length === 0) {
            if (!this.candidatesContainer.isFilterOn) {
                this.displayCandidateFilterFlag = false;
                this._setShowCandidateDisplayFilterIcon(true);
            }
            else {
                this.emptyCandidateSelectedFilter = true;
            }
        }
    }
    _setOpenGlobalFilter() {
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
    }
    _deleteSelectedItem(currentObject, deletedItem) {
        switch (currentObject.variable) {
            case 'firstName':
                this.candidatesContainer.candidatesQueryFilter.firstName = '';
                this.displayCandidateSelectedFilter.firstName = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'lastName':
                this.candidatesContainer.candidatesQueryFilter.lastName = '';
                this.displayCandidateSelectedFilter.lastName = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'phone':
                this.candidatesContainer.candidatesQueryFilter.phone = '';
                this.displayCandidateSelectedFilter.phone = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'email':
                this.candidatesContainer.candidatesQueryFilter.email = '';
                this.displayCandidateSelectedFilter.email = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'searchString':
                this.candidatesContainer.candidatesQueryFilter.searchString = '';
                this.displayCandidateSelectedFilter.searchString = '';
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'clientOrBuList':
                this.clientOrBuList.forEach((client, index) => {
                    if (client.name === deletedItem) {
                        client.ticked = false;
                        this.selectedClientOrBuList = this.selectedClientOrBuList.filter(item => item.name !== deletedItem);
                    }
                    else if (client.shortName === deletedItem) {
                        client.ticked = false;
                        this.selectedClientOrBuList = this.selectedClientOrBuList.filter(item => item.shortName !== deletedItem);
                    }
                });
                this.onClientClick();
                break;
            case 'status':
                this.candidateStatusList.forEach((canStatus, index) => {
                    if (canStatus.value === deletedItem) {
                        canStatus.ticked = false;
                        this.selectedCandidateStatusList = this.selectedCandidateStatusList.filter(item => item.value !== deletedItem);
                    }
                });
                this.onCandidateStatusClick();
                break;
            case 'requisitionStatus':
                this.requisitionStatusList.forEach((reqStatus, index) => {
                    if (reqStatus.name === deletedItem) {
                        reqStatus.ticked = false;
                        this.selectedRequisitionStatusList = this.selectedRequisitionStatusList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onRequisitionStatusClick();
                break;
            case 'requisitionNumbers':
                this.requisitionNumbersList.forEach((reqNum, index) => {
                    if (reqNum.value === deletedItem) {
                        reqNum.ticked = false;
                        this.selectedRequisitionNumbersList = this.selectedRequisitionNumbersList.filter(item => item.value !== deletedItem);
                    }
                });
                this.onRequisitionNumbersClick();
                break;
            case 'workflowStates':
                this.jobMatchStates.forEach((jobMatch, index) => {
                    if (jobMatch.value === deletedItem) {
                        jobMatch.ticked = false;
                        this.selectedJobMatchStates = this.selectedJobMatchStates.filter(item => item.value !== deletedItem);
                    }
                });
                this.onJobMatchStateClick();
                break;
            case 'vendors':
                this.vendors.forEach((vendor, index) => {
                    if (vendor.name === deletedItem) {
                        vendor.ticked = false;
                        this.selectedVendors = this.selectedVendors.filter(item => item.name !== deletedItem);
                    }
                });
                this.onVendorClick();
                break;
            case 'recruiterList':
                this.recruitersList.forEach((recruiter, index) => {
                    if (recruiter.name === deletedItem) {
                        recruiter.ticked = false;
                        this.selectedRecruitersList = this.selectedRecruitersList.filter(item => item.name !== deletedItem);
                    }
                    else if (recruiter.firstName === deletedItem) {
                        recruiter.ticked = false;
                        this.selectedRecruitersList = this.selectedRecruitersList.filter(item => item.firstName !== deletedItem);
                    }
                });
                this.onRecruiterClick();
                break;
            case 'workLocationIds':
                this.workLocationList.forEach((workLocation, index) => {
                    if (workLocation.name === deletedItem) {
                        workLocation.ticked = false;
                        this.selectedWorkLocationList = this.selectedWorkLocationList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onWorkLocationClick();
                break;
            case 'jobTypes':
                this.preferredJobTypeList.forEach((jobType, index) => {
                    if (jobType.name === deletedItem) {
                        jobType.ticked = false;
                        this.selectedPreferredJobTypeList = this.selectedPreferredJobTypeList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onPreferredJobTypeClick();
                break;
            case 'jobSubTypes':
                this.preferredJobTypeAdditionalList.forEach((additionalJobType, index) => {
                    if (additionalJobType.name === deletedItem) {
                        additionalJobType.ticked = false;
                        this.selectedPreferredJobTypeAdditionalList = this.selectedPreferredJobTypeAdditionalList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onAdditionalPreferredJobTypeClick();
                break;
            case 'sponsorships':
                this.workAuthorizationList.forEach((sponsorship, index) => {
                    if (sponsorship.value === deletedItem) {
                        sponsorship.ticked = false;
                        this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(item => item.value !== deletedItem);
                    }
                    else if (sponsorship.name === deletedItem) {
                        sponsorship.ticked = false;
                        this.selectedWorkAuthorizationList = this.selectedWorkAuthorizationList.filter(item => item.name !== deletedItem);
                    }
                });
                this.onWorkAuthorizationClick();
                break;
            case 'salary':
                this.candidatesContainer.candidatesQueryFilter.salary = null;
                this.displayCandidateSelectedFilter.salary = "";
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'rate':
                this.candidatesContainer.candidatesQueryFilter.rate = null;
                this.displayCandidateSelectedFilter.rate = "";
                this.isDisplayRateFilterActive = false;
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
                break;
            case 'selectedFilterSort':
                this.sortCandidates(null, null);
                break;
            default:
                break;
        }
    }
    deleteSelectedFilterItem(deletedItem) {
        this._setOpenGlobalFilter();
        for (var key in this.displayCandidateSelectedFilter) {
            if (this.displayCandidateSelectedFilter.hasOwnProperty(key)) {
                var obj = this.displayCandidateSelectedFilter[key];
                if (Array.isArray(obj)) {
                    if (obj.includes(deletedItem)) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
                else {
                    if (obj == deletedItem) {
                        this.deleteSelectedFilter = {};
                        this.deleteSelectedFilter = { variable: key, value: obj };
                        this._deleteSelectedItem(this.deleteSelectedFilter, deletedItem);
                    }
                }
            }
        }
    }
    getAllClientsOrBu(successCallback) {
        this.loadingClientsOrBusFilter = true;
        this.candidateService.getAllClientsOrBu(this.$rootScope.userDetails, (data) => {
            this.clientOrBuList = data;
            angular.forEach(this.clientOrBuList, (clientOrBu, key) => {
                if (clientOrBu.companyType == 'Corporation') {
                    clientOrBu.name = "<span style='padding-right:5px'>" + clientOrBu.name + "</span><i class='fas fa-share-alt'></i>";
                }
            });
            if (this.savedFilters !== null) {
                this.selectedClientOrBuList = this.clientOrBuList.filter(clientOrBu => this.savedFilters.clientOrBuList.some(clientOrBuId => clientOrBuId == clientOrBu.id));
                this.selectedClientOrBuList.forEach(clientOrBu => clientOrBu.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.clientOrBuList.length !== 0 || this.candidatesContainer.candidatesQueryFilter.clientOrBuList.length !== 0) {
                this.displayCandidateSelectedFilter.clientOrBuList = this.selectedClientOrBuList.map((val, index) => {
                    if (val.companyType === 'Corporation') {
                        return val.shortName;
                    }
                    else {
                        return val.name;
                    }
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            this.loadingClientsOrBusFilter = false;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingClientsOrBusFilter = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getAllJobMatchStates(successCallback) {
        this.loadingJobMatchStatesFilter = true;
        this.jobMatchService.getAllJobMatchStates((data) => {
            angular.forEach(data.candidateWorkflowCardStatus, (stepVal, stepKey) => {
                let stepEntry = {};
                stepEntry.name = stepVal.status;
                stepEntry.value = stepVal.status;
                stepEntry.label = "<b>" + stepVal.status + "</b>";
                stepEntry.stepGroup = true;
                this.jobMatchStates.push(stepEntry);
                angular.forEach(stepVal.states, (stateVal, stateKey) => {
                    let stateEntry = {};
                    stateEntry.name = stateVal;
                    stateEntry.value = stateVal;
                    stateEntry.label = stateVal;
                    stateEntry.ticked = false;
                    this.jobMatchStates.push(stateEntry);
                });
                stepEntry = {};
                stepEntry.stepGroup = false;
                this.jobMatchStates.push(stepEntry);
                this.loadingJobMatchStatesFilter = false;
            });
            if (this.savedFilters !== null) {
                this.selectedJobMatchStates = this.jobMatchStates.filter(jobMatchState => this.savedFilters.workflowStates.some(stateName => stateName == jobMatchState.value));
                this.selectedJobMatchStates.forEach(state => state.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.workflowStates.length !== 0 || this.candidatesContainer.candidatesQueryFilter.workflowStates.length !== 0) {
                this.displayCandidateSelectedFilter.workflowStates = this.selectedJobMatchStates.map((val, index) => {
                    return val.value;
                });
                this.displayCandidateSelectedFilter.workflowStates = this.displayCandidateSelectedFilter.workflowStates.filter(val => val !== undefined);
                // Filter Duplicate Values
                this.displayCandidateSelectedFilter.workflowStates = [...new Set(this.displayCandidateSelectedFilter.workflowStates)];
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.loadingJobMatchStatesFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    setCandidateInfo(candidateInfo, type) {
        // if a current container id exits, close it.
        if (!_.isNull(this.candidateInfoContainerId)) {
            this.closeCandidateInfoRow(this.candidateInfoContainerId);
        }
        //$('.candidate-info-container').hide();
        this.infoOfCandidateInContext = candidateInfo;
        let allCandidatesLength = this.candidatesContainer.candidates.length;
        let allCandidatesFullQuadrants = Math.floor(allCandidatesLength / this.divident);
        let currentCandidateQuadrant = Math.ceil(candidateInfo.candidateIndex / this.divident);
        let candidateInfoContainerId = null;
        if (this.isRowViewActive) {
            candidateInfoContainerId = `candidate-info-row-view-${candidateInfo.candidateIndex}`;
        }
        else {
            if (currentCandidateQuadrant <= allCandidatesFullQuadrants) {
                candidateInfoContainerId = 'candidate-info-' + (currentCandidateQuadrant * this.divident);
            }
            else {
                candidateInfoContainerId = 'candidate-info-' + allCandidatesLength;
            }
        }
        switch (type) {
            case 'jobMatches':
                this.candidateInfoTemplate = 'app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-job-matches-all.html';
                this.activeTabIndex = 1;
                break;
            case 'possibleJobMatches':
                this.candidateInfoTemplate = 'app/public/app/partials/missioncontrol/candidates/candidateCard/candidate-job-matches-all.html';
                this.activeTabIndex = 2;
                break;
            default:
                this.activeTabIndex = 1;
                break;
        }
        // time out needed for variables to refresh on view and reload the job matches directive.
        this.$timeout(() => {
            this.candidateInfoContainerId = candidateInfoContainerId;
            candidateInfo.jobMatchesPopoverIsOpenFlag = false;
            $("#" + candidateInfoContainerId).show();
            this.candidateJobMatchesTabChanged(type);
        }, 100);
    }
    closeCandidateInfoRow() {
        if (!_.isNull(this.candidateInfoContainerId)) {
            $('#' + this.candidateInfoContainerId).hide();
        }
        this.candidateInfoContainerId = null;
        this.sharedAjsService.resetRefreshJobMatchesListener();
        this.candidateJobMatchesTabChanged('jobMatches');
    }
    getAllCandidateStatuses(successCallback) {
        this.loadingCandidateStatusesFilter = true;
        this.candidateStatusList = [
            {
                "name": "Active",
                "value": "Active"
            },
            {
                "name": "Passive",
                "value": "Passive"
            },
            {
                "name": "Inert",
                "value": "Inert"
            }
        ];
        if (this.savedFilters !== null) {
            this.selectedCandidateStatusList = this.candidateStatusList.filter(status => this.savedFilters.status.some(statusName => statusName == status.name));
            this.selectedCandidateStatusList.forEach(status => status.ticked = true);
        }
        if (this.savedDisplayedCandidateSelectedFilter.status.length !== 0 || this.candidatesContainer.candidatesQueryFilter.status.length !== 0) {
            this.displayCandidateSelectedFilter.status = this.selectedCandidateStatusList.map((val, index) => {
                return val.value;
            });
            this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
        }
        this.loadingCandidateStatusesFilter = false;
        if (successCallback) {
            successCallback();
        }
    }
    getAllRequisitionStatuses(successCallback) {
        this.loadingRequisitionStatusesFilter = true;
        this.jobService.getAllStatusTypes((data) => {
            this.requisitionStatusList = data;
            if (this.savedFilters !== null) {
                this.selectedRequisitionStatusList = this.requisitionStatusList.filter(status => this.savedFilters.requisitionStatus.some(value => value == status.value));
                this.selectedRequisitionStatusList.forEach(status => status.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.requisitionStatus.length !== 0 || this.candidatesContainer.candidatesQueryFilter.requisitionStatus.length !== 0) {
                this.displayCandidateSelectedFilter.requisitionStatus = this.selectedRequisitionStatusList.map((val, index) => {
                    return val.name;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            this.loadingRequisitionStatusesFilter = false;
        }, (error) => {
            this.loadingRequisitionStatusesFilter = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getAllWorkLocations(successCallback) {
        this.loadingWorkLocationsFilter = true;
        this.jobService.getWorkLocations((data) => {
            this.workLocationList = data;
            if (this.savedFilters !== null && this.savedFilters.workLocationIds) {
                this.selectedWorkLocationList = this.workLocationList.filter(location => this.savedFilters.workLocationIds.some(id => location.id === id));
                this.selectedWorkLocationList.forEach(location => location.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.workLocationIds.length !== 0 || this.candidatesContainer.candidatesQueryFilter.workLocationIds.length !== 0) {
                this.displayCandidateSelectedFilter.workLocationIds = this.selectedWorkLocationList.map((val, index) => {
                    return val.name;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            this.loadingWorkLocationsFilter = false;
        }, (error) => {
            this.loadingWorkLocationsFilter = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getAllRecruiters(successCallback) {
        this.loadingRecruitersFilter = true;
        let clientOrBuId = null;
        let requisitionId = null;
        let clientOrBuIds = this.selectedClientOrBuList.map(clientOrBu => {
            return clientOrBu.id;
        });
        let requisitionNumbers = this.selectedRequisitionNumbersList.map(reqNumber => {
            return reqNumber.name;
        });
        let isUploadOrEditReq = false;
        this.jobService.getAllRecruiters(this.$rootScope.userDetails, this.$rootScope.userDetails.company, clientOrBuId, requisitionId, clientOrBuIds, requisitionNumbers, isUploadOrEditReq, (data) => {
            this.recruitersList = data.recruiters;
            angular.forEach(this.recruitersList, (val, key) => {
                let name = '';
                if (val.lastName !== null) {
                    name = val.firstName + " " + val.lastName;
                }
                else {
                    name = val.firstName;
                }
                val.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(name);
                val.name = name.length > 30 ? name.substring(0, 30) + "..." : name;
                val.name = val.name + ' <sup>R</sup>';
            });
            angular.forEach(data.hiringManagers, (val, key) => {
                let name = '';
                if (val.lastName !== null) {
                    name = val.firstName + " " + val.lastName;
                }
                else {
                    name = val.firstName;
                }
                val.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(name);
                val.name = name.length > 30 ? name.substring(0, 30) + "..." : name;
                val.name = val.name + ' <sup>H</sup>';
                this.recruitersList.push(val);
            });
            data.pocs.forEach(poc => {
                if (poc) {
                    let name;
                    if (poc.lastName !== null) {
                        name = poc.firstName + " " + poc.lastName;
                    }
                    else {
                        name = poc.firstName;
                    }
                    poc.selectedDisplayName = this.$filter('displayOnMultiSelectFilter')(name);
                    poc.name = name.length > 30 ? name.substring(0, 30) + "..." : name;
                    poc.name = poc.name + ' <sup>POC</sup>';
                    this.recruitersList.push(poc);
                }
            });
            if (this.visibilityFilters.unassigned != '') {
                if (!this.recruitersList.find(recruiter => recruiter.userId == 'UNASSIGNED'))
                    ;
                {
                    let unAssignedRecruiter = { name: 'Unassigned', selectedDisplayName: 'Unassigned', userId: 'UNASSIGNED' };
                    this.recruitersList.unshift(unAssignedRecruiter);
                }
            }
            if (this.visibilityFilters.assignedToMe != '') {
                if (!this._currentUserExistsInAssignedRecruitersList() && !this.userRoleService.isLoggedInUserSuperUserOr4dot5Admin()) {
                    this.recruitersList.unshift({ name: this.userName, selectedDisplayName: this.$filter('displayOnMultiSelectFilter')(this.userName), userId: this.userId, ticked: true });
                }
            }
            else {
                this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId !== this.userId);
            }
            this.selectedRecruitersList = this.selectedRecruitersList.filter(selectedRecruiter => this.recruitersList.find(recruiter => (recruiter.userId === selectedRecruiter.userId)));
            angular.forEach(this.selectedRecruitersList, (selectedRecruiter, key) => {
                angular.forEach(this.recruitersList, (recruiter, index) => {
                    if (recruiter.userId == selectedRecruiter.userId) {
                        recruiter.ticked = true;
                    }
                });
            });
            if (this.savedFilters !== null) {
                this.selectedRecruitersList = this.recruitersList.filter(recruiter => this.savedFilters.recruiterList.some(recruiterId => recruiterId == recruiter.userId));
                this.selectedRecruitersList.forEach(recruiter => recruiter.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.recruiterList.length !== 0 || this.candidatesContainer.candidatesQueryFilter.recruiterList.length !== 0) {
                this.displayCandidateSelectedFilter.recruiterList = this.selectedRecruitersList.map((val, index) => {
                    if (val.firstName === null || val.firstName === undefined) {
                        return val.name;
                    }
                    else {
                        return val.firstName;
                    }
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            this.loadingRecruitersFilter = false;
        }, (error) => {
            this.loadingRecruitersFilter = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    _removeOtherRecruiters() {
        this.recruitersList = this.recruitersList.filter(recruiter => recruiter.userId == this.userId || recruiter.userId == 'UNASSIGNED');
        this.selectedRecruitersList = [...this.recruitersList];
    }
    _currentUserExistsInAssignedRecruitersList() {
        let exists = this.recruitersList.some(recruiter => recruiter.userId === this.userId);
        return exists;
    }
    getAllRequisitionNumbers(successCallback) {
        this.loadingRequisitionNumbersFilter = true;
        let clientOrBuIds = this.selectedClientOrBuList.map(clientOrBu => {
            return clientOrBu.id;
        });
        let filter = { clientOrBuIds: clientOrBuIds, roleNames: [] };
        this.jobService.searchByReqNum(this.$rootScope.userDetails.id, this.$rootScope.userDetails.company.companyId, 'all', filter, (data) => {
            this.requisitionNumbersList = [];
            data.forEach((req) => {
                let icon = req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
                this.requisitionNumbersList.push({ 'name': req.reqNumber, 'value': req.reqNumber, 'selectedDisplayName': this.$filter('displayOnMultiSelectFilter')(req.reqNumber), 'icon': icon });
            });
            this.selectedRequisitionNumbersList = this.selectedRequisitionNumbersList.filter(selectedReqNumber => this.requisitionNumbersList.find(reqNumber => (reqNumber.name === selectedReqNumber.name)));
            angular.forEach(this.selectedRequisitionNumbersList, (selectedReqNumber, key) => {
                angular.forEach(this.requisitionNumbersList, (reqNum, index) => {
                    if (reqNum.name == selectedReqNumber.name) {
                        reqNum.ticked = true;
                    }
                });
            });
            if (this.savedFilters !== null) {
                this.selectedRequisitionNumbersList = this.requisitionNumbersList.filter(reqNum => this.savedFilters.requisitionNumbers.some(num => num == reqNum.value));
                this.selectedRequisitionNumbersList.forEach(req => req.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.requisitionNumbers.length !== 0 || this.candidatesContainer.candidatesQueryFilter.requisitionNumbers.length !== 0) {
                this.displayCandidateSelectedFilter.requisitionNumbers = this.selectedRequisitionNumbersList.map((val, index) => {
                    return val.value;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            if (successCallback) {
                successCallback();
            }
            this.loadingRequisitionNumbersFilter = false;
        }, (error) => {
            this.loadingRequisitionNumbersFilter = false;
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getReqNums(searchReqText) {
        if (searchReqText == "" || !angular.isDefined(searchReqText)) {
            searchReqText = "all";
        }
        let clientOrBuIds = this.selectedClientOrBuList.map(clientOrBu => {
            return clientOrBu.id;
        });
        let filter = { clientOrBuIds: clientOrBuIds, roleNames: [] };
        this.jobService.searchByReqNum(this.$rootScope.userDetails.id, this.$rootScope.userDetails.company.companyId, searchReqText, filter, (data) => {
            this.requisitionNumbersList = [];
            data.forEach((req) => {
                let icon = req.sharedRequisition ? '<i class="fas fa-share-alt"></i> ' : '<span class="pl-4"></span>';
                this.requisitionNumbersList.push({ 'name': req.reqNumber, 'value': req.reqNumber, 'selectedDisplayName': this.$filter('displayOnMultiSelectFilter')(req.reqNumber), 'icon': icon });
            });
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    filterByDate() {
        this.candidatesContainer.candidatesQueryFilter.fromDate = "";
        this.candidatesContainer.candidatesQueryFilter.toDate = "";
        if (angular.isDefined(this.selectedDateRange) && this.selectedDateRange !== "") {
            let array = this.selectedDateRange.split("-");
            this.candidatesContainer.candidatesQueryFilter.fromDate = array[0].toString().trim();
            this.candidatesContainer.candidatesQueryFilter.toDate = array[1].toString().trim();
        }
        else {
            this.selectedDateRange = "";
        }
    }
    getAllActivityTypes() {
        this.jobService.getActivityTypes((data) => {
            this.activityMap = [];
            angular.forEach(data, (val, key) => {
                this.activityMap[val.value] = val.name;
            });
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
        });
    }
    getSalaryDurationOptions() {
        this.jobService.getSalaryDurationOptions((data) => {
            this.salaryDurationOptions = data;
            let tempSalaryDurationOptions = _.cloneDeep(data);
            tempSalaryDurationOptions.map(duration => {
                duration.name = duration.name.slice(4);
            });
            this.filterSalaryDurationOptions = tempSalaryDurationOptions.filter(salaryDuration => salaryDuration.value === 'PER_YEAR');
            this.filterRateDurationOptions = tempSalaryDurationOptions.filter(rateDuration => rateDuration.value != 'PER_YEAR');
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllPreferredJobTypes() {
        this.loadingPreferredJobTypeFilter = true;
        this.jobService.getAllJobTypes((data) => {
            this.preferredJobTypeList = data;
            this.preferredJobTypeList.push({ name: "No Pref. Job Type", value: "NO_PREF_JOBTYPE" });
            if (this.savedFilters !== null && this.savedFilters.jobTypes) {
                this.selectedPreferredJobTypeList = this.preferredJobTypeList.filter(jobType => this.savedFilters.jobTypes.some(value => jobType.value === value));
                this.selectedPreferredJobTypeList.forEach(jobType => jobType.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.jobTypes.length !== 0 || this.candidatesContainer.candidatesQueryFilter.jobTypes.length !== 0) {
                this.displayCandidateSelectedFilter.jobTypes = this.selectedPreferredJobTypeList.map((val, index) => {
                    return val.name;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            this.loadingPreferredJobTypeFilter = false;
        }, (error) => {
            this.loadingPreferredJobTypeFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllAdditionalPreferredJobTypes() {
        this.loadingAdditionalPreferredJobTypeFilter = true;
        this.jobService.getAllJobSubTypes((data) => {
            this.preferredJobTypeAdditionalList = data;
            this.preferredJobTypeAdditionalList.push({ name: 'Not Specified', value: 'NO_PREF_JOBSUBTYPE' });
            if (this.savedFilters !== null && this.savedFilters.jobSubTypes) {
                this.selectedPreferredJobTypeAdditionalList = this.preferredJobTypeAdditionalList.filter(jobType => this.savedFilters.jobSubTypes.some(value => jobType.value === value));
                this.selectedPreferredJobTypeAdditionalList.forEach(jobType => jobType.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.jobSubTypes.length !== 0 || this.candidatesContainer.candidatesQueryFilter.jobSubTypes.length !== 0) {
                this.displayCandidateSelectedFilter.jobSubTypes = this.selectedPreferredJobTypeAdditionalList.map((val, index) => {
                    return val.name;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            this.loadingAdditionalPreferredJobTypeFilter = false;
        }, (error) => {
            this.loadingAdditionalPreferredJobTypeFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAllWorkAuthorizations() {
        this.loadingWorkAuthorizationFilter = true;
        this.jobService.getAllSponsorshipTypes((data) => {
            this.workAuthorizationList = data;
            if (this.savedFilters !== null && this.savedFilters.sponsorships) {
                this.selectedWorkAuthorizationList = this.workAuthorizationList.filter(work => this.savedFilters.sponsorships.some(value => work.value === value));
                this.selectedWorkAuthorizationList.forEach(jobType => jobType.ticked = true);
            }
            if (this.savedDisplayedCandidateSelectedFilter.sponsorships.length !== 0 || this.candidatesContainer.candidatesQueryFilter.sponsorships.length !== 0) {
                this.displayCandidateSelectedFilter.sponsorships = this.selectedWorkAuthorizationList.map((val, index) => {
                    return val.name;
                });
                this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
            }
            this.loadingWorkAuthorizationFilter = false;
        }, (error) => {
            this.loadingWorkAuthorizationFilter = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getCurrencyCodes() {
        this.jobService.getCurrencyCodes((data) => {
            this.currencyCodes = data;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setSalaryAndRate() {
        this.candidatesContainer.candidatesQueryFilter.includeWithoutCompensation = true;
        this._setSalaryAndRateDefaultValues('salary');
        this._setSalaryAndRateDefaultValues('rate');
    }
    _setDisplaySalaryAndRateFilter() {
        // Set salary and rate filter
        if (this.displayCandidateSelectedFilter.salary != "" && this.displayCandidateSelectedFilter.rate != "") {
            this.isDisplayRateFilterActive = true;
        }
        this.setCandidateDisplayedFilterItemSelected(this.displayCandidateSelectedFilter);
    }
    _setSalaryAndRateDefaultValues(type) {
        if (type === 'salary') {
            this.candidatesContainer.candidatesQueryFilter.salary = null;
            this.candidatesContainer.candidatesQueryFilter.salaryDuration = "PER_YEAR";
            this.candidatesContainer.candidatesQueryFilter.currency = "USD";
        }
        else {
            this.candidatesContainer.candidatesQueryFilter.rate = null;
            this.candidatesContainer.candidatesQueryFilter.rateDuration = "PER_HOUR";
            this.candidatesContainer.candidatesQueryFilter.currency = "USD";
        }
    }
    _checkIfSalaryAndRateDurationDefault(type) {
        if (type === 'salary') {
            if (!this.candidatesContainer.candidatesQueryFilter.salaryDuration || this.candidatesContainer.candidatesQueryFilter.salaryDuration == "") {
                this.candidatesContainer.candidatesQueryFilter.salaryDuration = "PER_YEAR";
            }
        }
        else {
            if (!this.candidatesContainer.candidatesQueryFilter.rateDuration || this.candidatesContainer.candidatesQueryFilter.rateDuration == "") {
                this.candidatesContainer.candidatesQueryFilter.rateDuration = "PER_HOUR";
            }
        }
        if (!this.candidatesContainer.candidatesQueryFilter.currency || this.candidatesContainer.candidatesQueryFilter.currency == "") {
            this.candidatesContainer.candidatesQueryFilter.currency = "USD";
        }
    }
    deleteCandidate(candidateId) {
        if (this.isRowViewActive) {
            let rowViewCandidateIndex = _.findIndex(this.candidatesContainer.candidatesPerPage, { 'id': candidateId });
            this.candidatesContainer.candidatesPerPage.splice(rowViewCandidateIndex, 1);
        }
        else {
            let candidateIndex = _.findIndex(this.candidatesContainer.candidates, { 'id': candidateId });
            this.candidatesContainer.candidates.splice(candidateIndex, 1);
        }
        this.candidatesContainer.candidatesCount = this.candidatesContainer.candidatesCount - 1;
    }
    _handleFilterDisplay() {
        $(document).ready(() => {
            $("#search-panel").hide();
            $(document).off("click", "#open-filter").on("click", "#open-filter", () => {
                $("#search-panel").animate({
                    height: 'toggle'
                });
                this.showFiltersPanel = !this.showFiltersPanel;
            });
        });
    }
    onGlobalFilterChange(event) {
        this.isFiltersChanged = true;
        if (!this.showFiltersPanel) {
            $("#search-panel").animate({
                height: 'toggle'
            });
            this.showFiltersPanel = true;
        }
        if (this._onEnterKeyPress(event)) {
            this.queryCandidates();
        }
    }
    _onEnterKeyPress(event) {
        return event && event.keyCode === 13;
    }
    candidateJobMatchesTabChanged(type) {
        this.candidateJobMatchActiveTab.candidateInfoContainerId = this.candidateInfoContainerId;
        this.candidateJobMatchActiveTab.type = type;
    }
}
class CandidatesContainer {
    constructor($rootScope, divident, candidateService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.divident = divident;
        this.candidateService = candidateService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
        this.$onInit();
    }
    $onInit() {
        this.candidates = [];
        this.candidatesPerPage = [];
        this.candidatesCount = 0;
        this.busy = false;
        this.loadingSearchButton = false;
        this.candidatesExistFlag = true;
        this.candidatesQueryFilter = new CandidatesQueryFilter(this.$rootScope.userDetails.company.companyId, this.$rootScope.userDetails.id);
        this.currentPromise = null;
        this.disableInfiniteScroll = false;
        this.isFilterOn = false;
        this.allAssignedRecruitersCount = null;
    }
    _getCandidates(successCallback, errorCallback) {
        this.currentPromise = this.candidateService.queryCandidateIdNames(this.candidatesQueryFilter, (data) => {
            if (successCallback) {
                successCallback(data);
            }
        }, (error) => {
            if (errorCallback) {
                errorCallback(error);
            }
        });
    }
    getNext() {
        if (this.busy)
            return;
        this.busy = true;
        if (this.candidatesQueryFilter.pageNum == '') {
            this.candidatesQueryFilter.pageNum = 1;
        }
        this._setIsFilterOn();
        this._getCandidates((data) => {
            if (angular.isDefined(data) && data != 'user cancellation') {
                this.candidatesCount = data.totalCandidateCount;
                if (data.candidatesNameDtos.length > 0) {
                    angular.forEach(data.candidatesNameDtos, (val, key) => {
                        if (key % this.divident == 0) {
                            val.jobMatchesPopoverPosition = 'bottom-left';
                        }
                        else if ((key + 1) % this.divident == 0) {
                            val.jobMatchesPopoverPosition = 'bottom-right';
                        }
                        else {
                            val.jobMatchesPopoverPosition = 'bottom';
                        }
                        val.candidateIndex = (this.candidates.length + 1);
                        val.jobMatchesPopoverIsOpenFlag = false;
                        this.candidates.push(angular.merge(new Candidate(), val));
                    });
                    // if the length of the returned values is less than page size, it means there are not enough values.
                    // hence we can disable the infinite scroll
                    if (data.candidatesNameDtos.length < this.candidatesQueryFilter.pageSize) {
                        this.disableInfiniteScroll = true;
                    }
                    else {
                        this.candidatesQueryFilter.pageNum++;
                    }
                }
                else {
                    // if the length of the returned values is 0, it means there are no more values.
                    // hence we can disable the infinite scroll
                    this.disableInfiniteScroll = true;
                }
                // set the candidates exist flag based on existence of candidates.
                if (this.candidates.length > 0) {
                    this.candidatesExistFlag = true;
                }
                else {
                    this.candidatesExistFlag = false;
                }
            }
            this.busy = false;
            this.loadingSearchButton = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.busy = false;
            this.loadingSearchButton = false;
        });
        //console.log('filter object in get next -', this.candidatesQueryFilter);
    }
    getNextPage(currentPage) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (this.busy)
            return;
        this.busy = true;
        this.candidatesQueryFilter.pageNum = currentPage ? currentPage : 1;
        this._setIsFilterOn();
        this.candidatesPerPage = [];
        this._getCandidates((data) => {
            if (angular.isDefined(data) && data != 'user cancellation') {
                this.candidatesCount = data.totalCandidateCount;
                if (data.candidatesNameDtos.length > 0) {
                    angular.forEach(data.candidatesNameDtos, (val, key) => {
                        val.candidateIndex = (this.candidatesPerPage.length + 1);
                        val.jobMatchesPopoverIsOpenFlag = false;
                        this.candidatesPerPage.push(angular.merge(new Candidate(), val));
                    });
                }
                // set the candidates exist flag based on existence of candidates.
                if (this.candidatesPerPage.length > 0) {
                    this.candidatesExistFlag = true;
                }
                else {
                    this.candidatesExistFlag = false;
                }
            }
            this.busy = false;
            this.loadingSearchButton = false;
        }, (error) => {
            if (this.$rootScope.isOnline) {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            }
            this.busy = false;
            this.loadingSearchButton = false;
        });
    }
    _setIsFilterOn() {
        let filter = this.candidatesQueryFilter;
        if (filter.status.length > 0
            || (filter.visibility.length == 3 && this.allAssignedRecruitersCount !== null && filter.recruiterList.length == this.allAssignedRecruitersCount)
            || filter.visibility.length < 3
            || filter.roleList.length > 0
            || filter.vendors.length > 0
            || filter.requisitionNumbers.length > 0
            || filter.workflowStates.length > 0
            || (filter.workLocationIds && filter.workLocationIds.length > 0)
            || filter.searchString.length > 0
            || filter.firstName.length > 0
            || filter.lastName.length > 0
            || (filter.email !== undefined && filter.email.length > 0)
            || (filter.phone !== undefined && filter.phone.length > 0)
            || filter.clientOrBuList.length > 0
            || filter.requisitionStatus.length > 0
            || (filter.column !== undefined && filter.sortDirection !== undefined)
            || filter.recruiterList.length > 0) {
            this.isFilterOn = true;
        }
        else {
            this.isFilterOn = false;
        }
    }
}
CandidatesPageController.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'StorageService', 'genericService', 'jobService', 'candidateService', 'jobMatchService', 'companyService', 'userRoleService', 'stateManagementStorageService', 'alertsAndNotificationsService', 'MESSAGECONSTANTS', 'sharedAjsService'];
// import * as TEMPLATE from './candidates-page.html';
import * as TEMPLATE from 'raw-loader!./candidates-page.html';
export const CandidatesPageComponent = {
    selector: 'candidatesPage',
    component: {
        bindings: { $transition$: '<' },
        template: TEMPLATE.default,
        // templateUrl: 'app/partials/missioncontrol/candidates/candidates-page.html',
        controller: CandidatesPageController
    }
};
//# sourceMappingURL=candidates-page.component.js.map